import res from './res'

res.add('ru', {
    dateFormat: 'DD.MM.YYYY HH:mm'
})
